import HttpFactory from '../HttpFactory'
import type IBasicObjectResponse from '../interfaces/IBasicObjectResponse'

export interface GuestBooking {
  id: number
  booking_number: string
  object_id: number
  status: string
  arrival: string
  departure: string
  nights: number
  guests: number
  status_url: string
  has_review: boolean
  total_price: number
  currency: string
}

export interface IGuestBookingsResponse extends IBasicObjectResponse {
  data: {
    upcoming: GuestBooking[]
    past: GuestBooking[]
  }
}

const extraHeaders = {
  'X-Requested-With': 'XMLHttpRequest'
}

class GuestBookingsModule extends HttpFactory {
  async getBookingsFromClient (): Promise<IGuestBookingsResponse> {
    return await this.callFetch<IGuestBookingsResponse>(
      'POST',
      'guest/bookings/get-bookings',
      null,
      extraHeaders
    )
  }
}

export default GuestBookingsModule
